// extracted by mini-css-extract-plugin
export default {"video":"AdaptiveVideo_video__guWwO","video__wrapper":"AdaptiveVideo_video__wrapper__oCsem","video__player":"AdaptiveVideo_video__player__dkqu2"};